import { Mail, MessageSquare, UserRound, PenLine, Send } from "lucide-react";

/* Contact Us page tour. No mobile mockup exists for this screen, so the steps
   are authored to match the page's own layout and the house tour style used
   across the app: email card → form → prefilled details → message → send. */
export default function getContactTourSteps() {
  return [
    {
      cardSelector: '[data-tour="co-email"]',
      targetSelector: '[data-tour="co-email"]',
      icon: <Mail />,
      title: "Email us directly",
      text: "Prefer email? Reach our team at support@mapmypay.com.",
    },
    {
      cardSelector: '[data-tour="co-form"]',
      targetSelector: '[data-tour="co-form"]',
      icon: <MessageSquare />,
      title: "Get in touch",
      text: "Or send us a message right here — no need to leave the app.",
    },
    {
      cardSelector: '[data-tour="co-form"]',
      targetSelector: '[data-tour="co-name"]',
      icon: <UserRound />,
      title: "Your details",
      text: "Your name and email are filled in automatically from your account.",
    },
    {
      cardSelector: '[data-tour="co-form"]',
      targetSelector: '[data-tour="co-message"]',
      icon: <PenLine />,
      title: "Your message",
      text: "Tell us what you need — at least 10 characters.",
    },
    {
      cardSelector: '[data-tour="co-form"]',
      targetSelector: '[data-tour="co-send"]',
      icon: <Send />,
      title: "Send",
      text: "Send it over and we'll get back to you by email.",
    },
  ];
}
